import { createSvgIcon } from '../../utils/helpers';
export default createSvgIcon({
  name: 'CheckboxTick',
  width: 1024,
  height: 1024,
  // eslint-disable-next-line max-len, comma-spacing
  paths: ['M361.623 639.977l-192.058-191.995-127.932 127.996 319.99 320.054 639.981-639.981-127.996-128.060-511.985 511.985z']
});